var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconParkOutlineDocSearch(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9922 2H4.99219C4.72697 2 4.47262 2.10536 4.28508 2.29289C4.09754 2.48043 3.99219 2.73478 3.99219 3V21C3.99219 21.2652 4.09754 21.5196 4.28508 21.7071C4.47262 21.8946 4.72697 22 4.99219 22H18.9922C19.2574 22 19.5118 21.8946 19.6993 21.7071C19.8868 21.5196 19.9922 21.2652 19.9922 21V3C19.9922 2.73478 19.8868 2.48043 19.6993 2.29289C19.5118 2.10536 19.2574 2 18.9922 2Z",
    stroke: "#FACC15",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9922 11.499L13.2597 9.76647M13.2597 9.76647C13.4966 9.5354 13.6854 9.25959 13.8149 8.95502C13.9444 8.65045 14.0122 8.32319 14.0143 7.99223C14.0164 7.66126 13.9527 7.33318 13.827 7.02701C13.7013 6.72084 13.516 6.44269 13.282 6.20867C13.0479 5.97466 12.7697 5.78944 12.4636 5.66378C12.1574 5.53811 11.8293 5.47449 11.4983 5.47661C11.1674 5.47873 10.8401 5.54655 10.5356 5.67613C10.231 5.80571 9.95522 5.99447 9.72419 6.23147C9.2588 6.70107 8.99839 7.33591 8.99993 7.99705C9.00147 8.6582 9.26484 9.29181 9.73241 9.75924C10.2 10.2267 10.8337 10.4899 11.4948 10.4912C12.156 10.4926 12.7902 10.232 13.2597 9.76647ZM8.49219 14.999H15.4922M8.49219 17.999H11.9922",
    stroke: "#FACC15",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconParkOutlineDocSearch);
export default __webpack_public_path__ + "static/media/icon-park-outline_doc-search.0a73b5e1bd11a0cdb3073def942cfade.svg";
export { ForwardRef as ReactComponent };